import { Button } from '@/ui/atoms/button/Button'
import { ErrorLayout } from '@/ui/layouts/ErrorLayout'

export function ErrorView() {
  return (
    <ErrorLayout>
      <div className="my-auto flex flex-col items-center justify-center gap-6 py-8">
        <div className="typography-heading-4">We couldn’t load your airdrop data. Try again later.</div>
        <Button onClick={() => window.location.reload()}>Reload</Button>
      </div>
    </ErrorLayout>
  )
}
